import { createFileRoute } from '@tanstack/react-router';
import PatientDetailPage from '@/pages/patients/PatientDetailPage';

export const Route = createFileRoute('/_authenticated/patients/$id/$tab')({
  component: PatientDetailPage,
});
